const state = {
  connected: false,
  localStream: null,
  remoteStream: null,
}

const mutations = {
  SET_CONNECTED (state, value) {
    state.connected = value
  },

  SET_LOCAL_STREAM (state, stream) {
    state.localStream = stream
  },

  SET_REMOTE_STREAM (state, stream) {
    state.remoteStream = stream
  },

  RESET_LOCAL_STREAM (state, stream) {
    state.localStream = null
  },

  RESET_REMOTE_STREAM (state, stream) {
    state.remoteStream = null
  },
}

const actions = {
  async stopStreaming ({ state, commit }) {
    commit('SET_CONNECTED', false)

    if (state.localStream !== null) {
      await state.localStream.getTracks().forEach(track => track.stop())
      commit('RESET_LOCAL_STREAM')
    }

    if (state.remoteStream !== null) {
      await state.remoteStream.getTracks().forEach(track => track.stop())
      commit('RESET_REMOTE_STREAM')
    }
  },
}

export default {
  namespaced: true,

  state,

  mutations,

  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/videoCall.js